import { Module } from '@nestjs/common'
import { AuthModule } from './auth'
import { BillingModule } from './billing'
import { DashboardModule } from './dashboard'
import { HealthModule } from './health'
import { MenuModule } from './menu'
import { MessageModule } from './message'
import { OrderModule } from './order'
import { ReportingModule } from './reporting'
import { ReservationModule } from './reservation'
import { RoomPlanModule } from './room-plan'
import { SettingsModule } from './settings'
import { StaticModule } from './static'
import { StorageModule } from './storage'
import { TenantModule } from './tenant'
import { UserModule } from './user'
import { WSModule } from './ws'

@Module({
	imports: [
		AuthModule,
		BillingModule,
		DashboardModule,
		HealthModule,
		MenuModule,
		MessageModule,
		OrderModule,
		ReportingModule,
		ReservationModule,
		RoomPlanModule,
		SettingsModule,
		StaticModule,
		StorageModule,
		TenantModule,
		UserModule,
		WSModule,
	],
})
export class FeaturesModule {}
